import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allCommand} from '../../api'
  
 
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cardamomList',
  setup(__props) {

  const typeStr = ref("0")
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);


  
  const page = reactive({ current: 1, limit: 10, total: 0,limits:[10,20,50,100,200] });

  const search = reactive({
    type: 0,
    state: 0
  })
  
  const columns = ref([
   
    { title: "口令", key: "key", align: "center" }, 
    { title: "天数", key: "days", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" },
    { title: "类型", key: "type", align: "center", customSlot: "type" }, 
    { title: "激活时间", key: "activationTime", align: "center" },   
    { title: "注册时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllDownloadStatistics = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "state": search.state ,"type":search.type};
    allCommand(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllDownloadStatistics();
  
  const change = (page: any) => {
    getAllDownloadStatistics();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllDownloadStatistics();
  }
   

  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: search,
                style: {"text-align":"start"},
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_form_item, {
                    label: "类型",
                    prop: "type",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: search.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.type) = $event)),
                        "show-search": true,
                        multiple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 0,
                            label: "全部"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "有效期"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "永久"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "状态",
                    prop: "state",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: search.state,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event)),
                        "show-search": true,
                        multiple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 0,
                            label: "全部"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "未激活"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "已激活"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, { mode: "inline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        size: "sm",
                        onClick: searchUser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "default-toolbar": true,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                type: _withCtx(({ row }) => [
                  (row.type==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "效期"))
                    : (row.type==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "永久"))
                      : _createCommentVNode("", true)
                ]),
                state: _withCtx(({ row }) => [
                  (row.state==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "未激活"))
                    : (row.state==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已激活"))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})